<script>
    import defaultState from './defaultState.js';
    import HealthBar from './HealthBar.svelte';
    import ImpactBar from './ImpactBar.svelte';
    import MainNav from './MainNav.svelte';
    import PageAndButtons from './PageAndButtons.svelte';
    import MonthBar from './MonthBar.svelte';
    import Music from './Music.svelte';
    import FadeOnNav from './FadeOnNav.svelte';
    import pages from './dataImport/spreadsheet.html';
    import {hasBackButton} from './common.js';
    import timeout from './timeout.js';
    console.log(pages);
    const elCoords = (el) => {
        const elRect = el.getBoundingClientRect();
        const bodyRect = document.body.getBoundingClientRect();
        return {
            x: elRect.left - bodyRect.left,
            y: elRect.top - bodyRect.top,
            w: elRect.width,
            h: elRect.height,
        };
    };

    const startsWith = (str, prefix) => str.lastIndexOf(prefix, 0) === 0;
    const stateFromCookie = () => {
        const cookies = document.cookie.split('; ');
        for (let i = 0; i < cookies.length; i++) {
            const cookie = cookies[i];
            if (startsWith(cookie, 'gameState=')) {
                try {
                    return JSON.parse(atob(cookie.substr(10)));
                } catch (e) {
                    console.log(e);
                }
            }
        }
        return null;
    };
    const initialState = () => {
        const cookieState = stateFromCookie();
        if (cookieState != null && cookieState.schema === defaultState.schema) {
            return cookieState;
        } else {
            const ret = JSON.parse(JSON.stringify(defaultState));
            if (cookieState != null && cookieState.soundEnabled != null) {
                ret.soundEnabled = cookieState.soundEnabled;
            }
            ret.lastActive = Date.now();
            return ret;
        }
    };

    // all state is stored here
    let state = initialState();

    let scrollEl = null;

    let playMusic = () => 0;
    let pauseMusic = () => 0;

    const characterToTable = { // map character names to table numbers
        // the numbers are the order that these tables appear within the game data document
        'worker': 1,
        'ceo': 2,
        'hr manager': 3,
        'call center rep': 4,
    };
    const characterTypes = Object.keys(characterToTable);
    const defaultStats = {
        'worker': {
            health: 5,
            impact: 2,
        },
        'ceo': {
            health: 7,
            impact: 7,
        },
        'hr manager': {
            health: 6,
            impact: 4,
        },
        'call center rep': {
            health: 3,
            impact: 4,
        },
    };

    const shouldCheckStats = () => {
        const firstChoice = pages[state.pageIndex].choices[0].dest;
        return state.character != null && firstChoice != 'back' && firstChoice != 'home' && firstChoice != 'choose your character';
    };

    const iconBarVerticalSpacing = (cur, change) => {
        const nums = cur.parentElement.children;
        const one = nums[7].getBoundingClientRect().top;
        const nother = nums[8].getBoundingClientRect().top;
        if (one && nother && one != nother) {
            return nother - one;
        }
        return 0;
    };

    let animationTimeout = null;
    const iconsToAnimate = {health: 0, impact: 0};
    const animateStatIconsNow = () => {
        animationTimeout = null;
        let delay = 0;
        for (const iconName in iconsToAnimate) {
            const change = iconsToAnimate[iconName];
            if (change != 0) {
                const icons = document.querySelectorAll(`.pageAndButtonsInner .${iconName}Icon`);
                const barCur = document.querySelector(`[data-icon="${iconName}"] [data-active="1"]`);
                if (barCur === null) {
                    continue;
                }
                const dY = iconBarVerticalSpacing(barCur, change);
                const healthBarCoords = elCoords(barCur);
                document.body.style.position = 'relative';
                for (let i = 0; i < icons.length; i++) {
                    const oldIcon = icons[i];
                    const icon = oldIcon.cloneNode(true);
                    icon.style.position = 'absolute';
                    const oldIconCoords = elCoords(oldIcon);
                    icon.style.top = oldIconCoords.y + 'px';
                    icon.style.left = oldIconCoords.x + 'px';
                    icon.style.transitionProperty = "top, left";
                    icon.style.transitionDuration = "1.1s, 1.1s";
                    timeout(0.01 + 0.2 * delay, () => {
                        document.body.appendChild(icon);
                        timeout(0.1, () => {
                            icon.style.top = healthBarCoords.y - ((-change + Math.sign(change) * (i + 1)) * Math.abs(dY)) + healthBarCoords.h / 2 - oldIconCoords.h / 2 + 'px';
                            icon.style.left = healthBarCoords.x + healthBarCoords.w / 2 - oldIconCoords.w / 2 + 'px';
                        });
                        timeout(1.1, () => document.body.removeChild(icon));
                    });
                    delay += 1;
                }

                iconsToAnimate[iconName] = 0;
            }
        }
    };
    const animateStatIcon = (iconName, change) => {
        iconsToAnimate[iconName] += change;
        if (animationTimeout !== null) {
            clearTimeout(animationTimeout);
        }
        animationTimeout = timeout(0.8, animateStatIconsNow);
    }
    const applyStateChanges = (msgs) => {
        const soundEnabledBefore = state.soundEnabled;
        for (const [key, op, arg] of msgs) {
            if (op === '+' || op === '+min1') {
                const oldValue = state[key];
                const proposedValue = oldValue + arg;
                const newValue = (op === '+min1') ? Math.max(1, proposedValue) : proposedValue;
                if (op === '+min1') {
                    state[`${key}PreMin1`] = oldValue;
                }
                if (newValue !== oldValue) {
                    const change = newValue - oldValue;
                    state[key] = newValue;
                    if (iconsToAnimate[key] != null) {
                        animateStatIcon(key, change);
                    }
                }
            } else if (op === '=') {
                state[key] = arg;
            } else if (op === 'push') {
                state[key] = state[key].concat([arg]);
            } else if (op === 'shift') {
                state[key] = state[key].slice(1);
            } else if (op === '!') {
                state[key] = !state[key];
            } else if (op === 'reset') {
                const soundEnabled = state.soundEnabled;
                // const healthExplained = state.healthExplained;
                state = JSON.parse(JSON.stringify(defaultState));
                state.soundEnabled = soundEnabled;
                // state.healthExplained = healthExplained;
            }
        }
        if (soundEnabledBefore != state.soundEnabled) {
            if (state.soundEnabled) {
                playMusic();
            } else {
                pauseMusic();
            }
        }
    };
    const scheduleInterruption = (interruption) => {
        for (let i = 0; i < state.interruptions.length; i++) {
            const oldInterruption = state.interruptions[i];
            if (oldInterruption.dest === interruption.dest) {
                return;
            }
        }
        state.interruptions = state.interruptions.concat([interruption]);
    };
    const reduce = (message, save = true) => {
        if (message.roll != null) {
            const choices = pages[state.pageIndex].choices;
            const roll = pages[state.pageIndex].d10 == null
                ? message.roll
                : ((state.impact >= Math.floor(Math.random() * 10)) ? 1 : 2)
            ;
            for (const choice of choices) {
                const [minTxt, maxTxt] = choice.text.split('-');
                const min = parseInt(minTxt.trim());
                const max = maxTxt ? parseInt(maxTxt.trim()) : min;
                if (roll >= min && roll <= max) {
                    reduce(choice, false);
                    break;
                }
            }
        }
        // apply state changes in choice
        if (message.state) {
            applyStateChanges(message.state);
        }
        // apply dest (page change)
        if (message.dest != null) {
            console.log('dest');
            if (/^chose /.test(message.dest)) {
                const character = message.dest.substr("chose ".length);
                if (character === 'random') {
                    state.character = characterTypes[Math.floor(Math.random() * characterTypes.length)];
                } else {
                    state.character = character;
                }
                state.health = defaultStats[state.character].health;
                state.impact = state.startingImpact = defaultStats[state.character].impact;
                state.pageIndex = `chose ${state.character}`;
            } else if ('* intro' === message.dest) {
                state.pageIndex = `${state.character} intro`;
            } else if ('* january' === message.dest) {
                state.pageIndex = `t${characterToTable[state.character]}r01`;
            } else if ('back' === message.dest) {
                state.pageIndex = state.back[0];
                state.back = state.back.slice(1);
            } else if ('interrupt' === message.dest) {
                const oldPage = pages[state.pageIndex];
                let afterInterruptionPageIndex;
                if (oldPage.choices.length === 1 && (oldPage.choices[0].text === 'Continue' || oldPage.choices[0].text === 'Got it!') && oldPage.choices[0].state == null) {
                    // If the interrupt button is replacing just a single button that says "Continue" on it, then skip this page on the way back
                    afterInterruptionPageIndex = oldPage.choices[0].dest;
                    console.log('not coming back here');
                } else {
                    // There's a choice to be made or a consequence, so come back here after
                    afterInterruptionPageIndex = state.pageIndex;
                }
                if (afterInterruptionPageIndex !== 'back') {
                    state.back = [afterInterruptionPageIndex].concat(state.back);
                }
                state.pageIndex = state.interruptions[0].dest;
                state.interruptions = state.interruptions.slice(1);
            } else {
                if (hasBackButton(message.dest) && !hasBackButton(state.pageIndex)) {
                    state.back.push(state.pageIndex);
                }
                state.pageIndex = message.dest;
            }
            // apply state changes in dest
            if (pages[state.pageIndex].state && message.dest !== 'back') {
                applyStateChanges(pages[state.pageIndex].state);
            }
            // we navigated, scroll to top
            if (scrollEl != null) {
                scrollEl.scrollTop = 0;
            }
        }
        // apply special rules and health/impact min/max
        if (shouldCheckStats()) {
            if (state.character === 'worker' && state.health >= 7) {
                scheduleInterruption({dest: 'worker health 7'});
            }
            if (state.impact < 1) {
                if (state.character === 'ceo') {
                    scheduleInterruption({dest: 'ceo impact 0'});
                    state.impact = 0;
                } else {
                    state.impact = 1;
                }
            }
            if (state.health < 1) {
                scheduleInterruption({dest: `${state.character} health 0`});
                state.health = 0;
            }
            if (state.health > 10) {
                state.health = 10
            }
            if (state.impact > 10) {
                state.impact = 10;
            }
            if (state.healthExplained == false && state.health < defaultStats[state.character].health) {
                state.healthExplained = true;
                scheduleInterruption({dest: 'first health loss'});
            }
            if (state.impactExplained == false && state.impact != defaultStats[state.character].impact) {
                state.impactExplained = true;
                scheduleInterruption({dest: `${state.character} impact`});
            }
        }
        if (state.soundEnabled) {
            playMusic();
        }
        state.lastActive = Date.now();
        console.log(JSON.stringify(state));
        document.cookie = "gameState=" + btoa(JSON.stringify(state)) + "; expires=" + new Date(86400000 * 30 + Date.now()).toUTCString() + ';';
        console.log("document.cookie = " + JSON.stringify("gameState=" + btoa(JSON.stringify(state)) + "; expires=" + new Date(86400000 * 30 + Date.now()).toUTCString() + ';'));
    };
    const onMessage = (e) => {
        console.log('onMessage', JSON.stringify(e));
        reduce(e.detail);
    };

    if (state.lastActive == null || state.lastActive < new Date() - 3600000) {
        if (state.pageIndex !== 'home') {
            reduce({dest: "welcome back"});
        }
    }
</script>


<div class="outer">
    <div class="health">
        <HealthBar value={state.health} pulse={pages[state.pageIndex].pulseHealth === true}/>
    </div>
    <div class="impact">
        <ImpactBar value={state.impact} pulse={pages[state.pageIndex].pulseImpact === true} isCeo={state.character == 'ceo'}/>
    </div>
    <div class="middle" bind:this={scrollEl}>
        <FadeOnNav on:message={onMessage}>
            <MainNav {state}/>
            <PageAndButtons {state}/>
        </FadeOnNav>
    </div>
    <div class="month">
        <MonthBar value={state.pageIndex.substr(2, 3)}/>
    </div>
</div>
<Music bind:play={playMusic} bind:pause={pauseMusic}/>

<style lang="less">
    @import "./common.less";

    div.outer {
        width: 100%;
        height: 100%;
        text-align: left;
        background-color: @backgroundColor;
        color: @textColor;
    }
    div.middle {
        position: relative;
        min-height: 100%;
        overflow-y: scroll;
        box-sizing: border-box;
    }
    .desktop({
        div.outer {
            padding: 0 20px; box-sizing: border-box;
            display: flex;
            flex-direction: row;
            gap: 20px;
            flex-wrap: nowrap;
            justify-content: stretch; /* along flex-direction */
            align-items: stretch; /* perpendicular to flex-direction */
        }
        div.health, div.impact {
            flex: 0 0 77px;
            position: relative;
        }
        div.middle {
            padding: 20px 0;
            flex: 1 1 0;
            display: flex;
            flex-direction: column;
        }
        div.middle::-webkit-scrollbar {
            width: 10px;
        }
        div.middle::-webkit-scrollbar-track {
            background: transparent;
        }
        div.middle::-webkit-scrollbar-thumb {
            background: #2222;
        }
        div.middle::-webkit-scrollbar-thumb:hover {
            background: #4442;
        }
        div.middle > :global(*) {
            min-height: calc(100vh - 40px);
            display: flex;
            flex-direction: column;
        }
        div.middle > :global(*) > :global(:nth-child(1)) {
            flex: 0 0 auto;
        }
        div.middle > :global(*) > :global(:nth-child(2)) {
            flex: 1 0 auto;
        }
        div.month {
            flex: 0 0 130px;
            position: relative;
        }
    });
    .mobile({
        div.outer {
            display: grid;
            grid-template-areas: "health impact month" ". . ." "middle middle middle";
            grid-template-columns: auto auto 1fr;
            grid-template-rows: auto 4px 1fr;
        }
        div.health, div.impact, div.month {
            height: 1em;
            min-width: 50px;
        }
        div.health {
            grid-area: health;
        }
        div.impact {
            grid-area: impact;
        }
        div.month {
            grid-area: month;
        }
        div.middle {
            grid-area: middle;
        }

    });
</style>